import React from 'react';
import { backCrossIcon, backIcon, back_Icon } from '../../images';
import { ActionButton } from '../buttons/Buttons';
import { cancelButtonTheme } from '../../theme/actionTheme';

export const close = {
  icon: backCrossIcon,
  // visible: ({navigation}) => {
  //   const count = navigation.getRouteCount();
  //   if (count > 1) {
  //     return true;
  //   }
  // },
  type: 'close',
};

export const back = {
  icon: backIcon,
  visible: ({ screenState } = {}) => {
    let selectionCount =
      screenState && screenState.selectedIds && screenState.selectedIds.length;
    if (selectionCount) {
      return false;
    }
    return true;
  },
  type: 'close',
};

export const unSelectAll = {
  icon: backCrossIcon,
  visible: ({ screenState } = {}) => {
    let selectionCount =
      screenState && screenState.selectedIds && screenState.selectedIds.length;
    if (selectionCount) {
      return true;
    }
    return false;
  },
  type: 'unSelectAll',
};
export const cancelButton = ({
  id,
  label,
  text,
  icon = back_Icon,
  description = 'Back',
  ...restProps
} = {}) => {
  label = label || text || 'Back';
  const { navigation } = restProps;
  const tooltipId = navigation?.state?.routeName;

  const imageStyle = { width: 32, height: 32 };

  return {
    id: label,
    label,
    type: 'close',
    render: () => {
      return (
        <ActionButton
          imageStyle={imageStyle}
          theme={cancelButtonTheme}
          description={description}
          label={label}
          icon={icon}
          tooltipId={tooltipId}
          {...restProps}
        />
      );
    },
  };
};

export const CancelButton = ({
  id,
  label,
  text,
  icon = back_Icon,
  description = 'Back',
  ...restProps
} = {}) => {
  // label = label || text || 'Back';
  const { navigation } = restProps;
  const tooltipId = navigation?.state?.routeName;

  const imageStyle = { width: 32, height: 32 };

  return {
    id: label,
    label,
    type: 'close',
    render: () => {
      return (
        <ActionButton
          imageStyle={imageStyle}
          theme={cancelButtonTheme}
          // description={description}
          label={label}
          icon={icon}
          tooltipId={tooltipId}
          {...restProps}
        />
      );
    },
  };
};


export const closeAction = ({ navigation }) => {
  navigation && navigation.goBack();
};

export const unSelectAllAction = ({ setScreenState } = {}) => {
  setScreenState && setScreenState({ selectedIds: [], allPageSelected: false });
};
